export enum UploadActionTypes {
  UPLOAD_FILE_COMPLETED = 'UPLOAD_FILE_COMPLETED'
}

export interface IUploadFileCompletedAction {
  type: UploadActionTypes.UPLOAD_FILE_COMPLETED;
}

export type UploadActions = IUploadFileCompletedAction;
